<template>
  <div class="home-ads" :class="theme">
    <!-- <div v-lazy-container="{ selector: 'img' }"> -->
    <!-- New Shops -->
    <div v-if="newShops && newShops.length >= 4">
      <!-- <div class="adset-title">{{ $t("new") }}</div> -->
      <div class="adset-title">{{ $t("home2.new-on-tuk") }}</div>
      <div class="btns single-line no-scrollbar gpu-accelerated" :class="theme">
        <div class="list-padding" />
        <div
          v-for="b in newShops"
          :key="'n' + b.name"
          class="bt"
          @click="goToBind(b.action, b.business_id)"
        >
          <!-- <img :src="b.img" class="normal" v-img-fallback="imgFallback" /> -->
          <img v-webp="b.img" class="normal" />
          <p class="name">{{ $t(b.name) }}</p>
        </div>
        <div class="list-padding" />
      </div>
    </div>

    <!-- Recent and Favorites -->
    <div class="adset-title">{{ $t("home2.recent-and-favorites") }}</div>
    <div
      v-if="recentOrders.length"
      class="btns single-line no-scrollbar gpu-accelerated"
      :class="theme"
    >
      <div class="list-padding" />
      <div v-for="b in recentOrders" :key="b.name" class="bt">
        <div v-if="b.isRide" class="transport" @click="b.action">
          <!-- <img :src="b.img" v-img-fallback="imgFallback" /> -->
          <img v-webp="b.img" />
          <p>{{ b.name }}</p>
        </div>
        <div v-else @click="goToBind(b.action, b.business_id)">
          <!-- <img :src="b.img" class="normal" v-img-fallback="imgFallback" /> -->
          <img v-webp="b.img" class="normal" />
        </div>
        <p class="name">{{ b.name }}</p>
      </div>
      <div class="bt" @click="$emit('favorite')">
        <img src="/img/home2/add-favorite.png" class="favorite-square" />
        <p style="width: 90px; overflow: hidden; text-overflow: ellipsis">
          {{ $t("home2.add-favorite") }}
        </p>
      </div>
      <div class="list-padding" />
    </div>
    <div v-else class="btns no-scrollbar placeholder">
      <div
        class="bt is-flex"
        style="width: 250px; margin-left: 20px"
        @click="$emit('favorite')"
      >
        <div style="margin: auto 6px; width: 120px">
          <img src="/img/home2/add-favorite.png" class="img60" />
        </div>
        <div style="margin: auto; padding-right: 6px; text-align: left">
          <i>{{ $t("home2.easily-reorder-from-favorite") }}</i>
        </div>
      </div>
    </div>

    <!-- Top Eats -->
    <!-- <div> -->
    <div class="adset-title">{{ $t("home2.top-eats") }}</div>
    <div
      v-if="topEateries.length"
      class="btns single-line no-scrollbar gpu-accelerated"
      :class="theme"
    >
      <!-- <div class="columns is-mobile is-vcentered is-uppercase"> -->
      <div class="list-padding" />
      <div
        v-for="b in topEateries"
        :key="b.name"
        class="bt"
        @click="goToBind(b.action, b.business_id)"
      >
        <!-- <img :src="b.img" class="normal" v-img-fallback="imgFallback" /> -->
        <img v-webp="b.img" class="normal" />
        <p class="name">{{ $t(b.name) }}</p>
      </div>
      <div class="list-padding" />
    </div>
    <div v-else class="btns no-scrollbar placeholder">
      <div
        class="bt is-flex"
        style="width: 250px; margin-left: 20px"
        @click="goToEat"
      >
        <div style="margin: auto 6px; width: 74px">
          <img src="/img/home2/location.svg" class="img60" />
        </div>
        <div style="margin: auto; padding-right: 6px; text-align: left">
          <i>{{ $t("See top eateries around you") }}</i>
        </div>
      </div>
    </div>
    <!-- </div> -->

    <!-- <div class="adset-title">{{ $t("home2.for-business") }}</div>
    <div
      class="btns single-line no-scrollbar gpu-accelerated"
      style="font-weight: 450"
    >
      <div class="list-padding" />
      <div
        v-for="b in businessButtons"
        :key="b.text"
        class="bt"
        style="width: 180px"
        @click="handleAction(b)"
      >
        <div style="margin-top: 8px">
          <img :src="b.img" class="img50" />
        </div>
        <div style="margin-top: -5px">
          <i>{{ b.text }}</i>
        </div>
      </div>
      <div class="list-padding" />
    </div> -->
  </div>
</template>

<script>
import vehicles from "@/vehicles";

export default {
  name: "HomeAds",
  data() {
    return {
      // newShops: this.$store.state.newShops, // new active shops, not hidden, with commerce workflow, must have prof pic
      // z: 0, // for lang change on for business
      arr1: this.$store.state.eateries,
      arr2: this.$store.state.eateries,
      maxItems: 20,
      maxNewShops: 6,
      imgFallback: {
        loading: this.$store.state.menuItemPlaceholderPic, //birdProfilePic,
        error: this.$store.state.errorProfilePic,
      },
    };
  },
  computed: {
    theme() {
      return this.$store.state.theme;
    },
    newShops() {
      var newShops = this.$store.state.newShops;
      if (!newShops) return null;
      if (newShops.length > this.maxNewShops)
        return newShops.slice(0, this.maxNewShops);
      return newShops;
    },
    flashDealClass() {
      if (this.theme === "dark") return "is-dark";
      return "is-white";
    },
    showPromos() {
      return this.$store.state.region === "Chiang Mai";
    },
    promoButtons() {
      return [
        {
          text: this.$t("promos.aircon-service"),
          img: "/img/home2/air-conditioner.svg",
          action: "goto",
          link: "/shop/7252a5ee-8167-11ea-b937-e60faa921629",
        },
        {
          text: this.$t("promos.flower-bouquets"),
          img: "/img/home2/flower.svg",
          action: "goto",
          link: "/shop/6fde6059-6c14-11eb-9ab2-96c15b56ceba",
        },
        {
          text: this.$t("promos.restaurant-discounts"),
          img: "/img/home2/gift.svg",
          action: "goto",
          link: "/eat?s=_promo",
        },
        {
          text: this.$t("promos.free-food-delivery"),
          img: "/img/home2/delivery-man.svg",
          action: "goto",
          link: "/eat?s=*free-delivery",
        },
        // {
        //   text: this.$t("promos.free-motorbike-ride"),
        //   img: "/img/vehicles/moto.png",
        //   action: "goto",
        //   link: "/ride?promo=free", // show "use promo code FREE to claim your free motorbike ride"
        // },
      ];
    },
    businessButtons() {
      return [
        {
          text: this.$t("home2.earn-affiliate-revenue"),
          img: "/img/home2/new-affiliate.png",
          action: this.goToForm,
          link: this.$t("url.new-affiliate-form"),
        },
        {
          text: this.$t("home2.register-new-shop"),
          img: "/img/home2/new-shop.png",
          action: this.goToForm,
          link: this.$t("shop.sign-up-form"),
        },
        {
          text: this.$t("home2.become-a-driver"),
          img: "/img/home2/new-driver.png",
          action: this.goToForm,
          link: this.$t("url.new-driver-form"),
        },
        {
          text: this.$t("home2.setup-your-fleet"),
          img: "/img/home2/new-fleet.png",
          action: this.goToForm,
          link: this.$t("url.new-fleet-form"),
        },
        {
          text: this.$t("home2.partner-with-tuk"),
          img: "/img/home2/new-partner.png",
          action: this.goToForm,
          link: this.$t("url.new-partner-form"),
        },
      ];
    },
    lang() {
      return this.$store.state.language;
    },
    recentOrders() {
      var orders = this.$store.getters.getRecentCustomerTransactions;
      var arr = this.prepRecent(orders);
      arr = arr.concat(this.prepFavoriteEateries());
      return (arr = arr.filter(
        (o, index, self) => index === self.findIndex((t) => t.name === o.name)
      ));
    },
    nearbyEateries() {
      //   var arr = this.$store.state.eateries;
      var arr = this.sortDistance(this.arr1);
      return this.prepEateries(arr);
    },
    topEateries() {
      var arr = this.$store.state.eateries;
      arr = arr.filter((b) => !b.data.hidden); // hide hidden shops from list
      arr = arr.filter((b) => b.workflows); // hide shops without commerce workflow list
      arr = this.sortForYou(arr);
      //   var arr = this.sortForYou(this.arr2);
      return this.prepEateries(arr);
    },
  },
  mounted() {
    this.getNewShops(); // do it once on mounted, not everytime activated
    this.$store.subscribe((mutation) => {
      if (mutation.type === "setLanguage") this.z += 1;
      if (mutation.type === "setRegion") this.getNewShops(); // do if region changed
    });
  },
  methods: {
    getNewShops() {
      var coords = this.$store.getters.getUserLocationString;
      if (!coords) return; // need coords to get nearby new shops
      this.$store
        .dispatch("getNewShops", coords)
        .then((res) => {
          if (!res.data) return;
          var newShops = res.data.map((b) => {
            return {
              business_id: b.id,
              name: b.name,
              img: b.product_pic_url || b.profile_pic_url,
              action: this.gotoDelay,
            };
          });
          // should check isShopOpenByID()
          this.$store.commit("setNewShops", newShops); // returns list of 15 nearby, new shops
        })
        .catch((err) => console.error("getNewShops", err));
    },
    sortDistance(arr) {
      return arr.sort((a, b) => {
        return a.distance < b.distance ? -1 : a.distance > b.distance ? 1 : 0;
      });
    },
    sortForYou(arr) {
      return arr.sort((a, b) => {
        return a.foryou > b.foryou ? -1 : a.foryou < b.foryou ? 1 : 0;
      });
    },
    prepEateries(arr) {
      var prepped = arr
        .map((b) => {
          return {
            business_id: b.id,
            name: b.name,
            img: b.profile_pic_url,
            action: this.gotoDelay,
          };
        })
        .filter((b) => b.img);
      if (prepped.length < this.maxItems) return prepped;
      return prepped.slice(0, this.maxItems);
    },
    prepRecent(orders) {
      return orders.map((o) => {
        var obj = {
          business_id: o.business.id,
          name: o.business.name,
          img: o.business.profile_pic_url || this.vehicleImg(o.workflow),
          action: this.gotoDelay,
          isRide: this.isRide(o.workflow),
        };
        if (obj.isRide) {
          obj.action = this.goToRide;
          var arr = ["Private Tuk Tuk", "Private"];
          if (!arr.includes(o.workflow.name)) {
            obj.name = this.translateTransportType(o.workflow.name);
          }
        }
        return obj;
      });
    },
    prepFavoriteEateries() {
      return this.$store.getters.getFavoriteEateries.map((b) => {
        var obj = {
          business_id: b.id,
          name: b.name,
          img: b.profile_pic_url,
          action: this.gotoDelay,
          isRide: false,
        };
        return obj;
      });
    },
    isRide(w) {
      var arr = [
        "Fleet",
        "Private Tuk Tuk",
        "Sii Lor",
        "Motocy",
        "Public Tuk Tuk",
        "Songthaew",
        "Taxi",
      ];
      return arr.includes(w.workflow_type_name);
    },
    vehicleImg(w) {
      var iconName = w.data.icon || w.name;
      return vehicles.img(iconName);
    },
    openHelp() {
      this.log("open_help");
      var url = `https://tukapp.freshdesk.com/support/solutions`;
      setTimeout(() => window.open(url, "_blank"), 500);
    },
    openLogisticsForm() {
      this.log("open_logistics");
      var url = this.$t("logistics.type-form-url");
      setTimeout(() => window.open(url, "_blank"), 500);
    },
    openToursForm() {
      this.log("open_tours");
      var url = this.$t("tours.type-form-url"); // https://tukapp.typeform.com/to/c0ZK0Jnr
      // var url = `https://tukapp.typeform.com/to/THUq5DWN`; //this.$t("logistics.type-form-url");
      setTimeout(() => window.open(url, "_blank"), 500);
    },
    handleAction(o) {
      if (o.action === "goto") {
        this.goto(o.link);
        return;
      }
      if (o.link) this.goToForm(o.link);
      else this.warningToast(`Unknown action ${JSON.stringify(o)}`);
    },
    goToForm(url) {
      window.open(url, "_blank");
    },
    goToBind(fn, id) {
      fn("shop/" + id);
    },
    goToShops() {
      this.gotoDelay("shop?tab=shops");
    },
    goToServices() {
      this.gotoDelay("shop?tab=services");
    },
  },
};
</script>

<style scoped>
.home-ads {
  position: relative;
  /* width: 100vw; */
  width: calc(100% + 80px);
  left: -40px;
  /* left: 0; */
  /* padding-bottom: 30px; */
  text-align: left;
}
.adset-title {
  text-align: left;
  margin-left: 20px;
  margin-bottom: 0;
  margin-top: 20px;
  opacity: 0.75;
  font-weight: 550;
  font-size: 1.2em;
}
.single-line {
  white-space: nowrap;
  overflow: auto;
  margin-bottom: -10px;
  /* display: inline-block; */
}
.btns {
  /* padding-left: 20px; */
  margin-bottom: 4px;
  /* width: 100vw; */
  /* width: 100%; */
  /* display: inline-block; */
  /* margin-top: 10px; */
  font-weight: 550; /* has-text-weight-bold */
  font-size: 0.85em;
  /* text-align: left; */
}
.bt {
  display: inline-block;
  margin-top: 10px;
  margin: 4px;
  /* padding: 5px; */
  /* width: 90px;
  height: 90px; */
  width: 120px;
  height: 120px;
  background-color: rgba(255, 255, 255, 0.9);
  border-radius: 3px;
  /* box-shadow: 4px 4px 10px rgba(0, 0, 0, 0.35); */
  /* box-shadow: 2px 2px 2px rgba(0, 0, 0, 0.2); */
  box-shadow: 0px 0px 6px rgba(0, 0, 0, 0.05);
  text-align: center;
}
img.normal {
  border-radius: 3px;
  object-fit: cover;
  /* height: 90px;
  width: 90px; */
  width: 120px;
  height: 120px;

  /* background: rgba(128, 128, 128, 0.5); */
  /* padding: 1px; */

  /* border: 1px solid white; */
  /* box-shadow: 0 0 0 2px #d3d3d4, 2px 2px 3px rgba(0, 0, 0, 0.35); */
  /* box-shadow: 0px 0px 5px rgba(0, 0, 0, 0.14); */
}
.transport img {
  /* height: 70px;
  width: 70px; */
  /* px 120 - 20 */
  height: 100px;
  width: 100px;
}
.transport p {
  position: relative;
  top: -15px;
}
.bt p {
  position: relative;
  z-index: 2;
  /* text-shadow: 1px 0px 1px rgba(0, 0, 0, 0.35); */
}
.dark .bt {
  /* background-color: rgba(17, 34, 51, 0.8); */
  background-color: #1f1b24;
  color: white;
}
.dark .adset-title,
.dark p {
  color: white;
}
.list-padding {
  display: inline-block;
  width: 16px;
}
.img60 {
  height: 60px;
  width: 60px;
}
.favorite-square {
  /* px 120 - 30 */
  height: 90px;
  width: 90px;
  margin: 15px;
}
.placeholder {
  margin-bottom: 12px;
  font-weight: 450;
}
.placeholder .bt {
  display: inline-block;
}
.bt:active {
  transform: scaleY(0.95);
}
.name {
  width: 120px;
  overflow: hidden;
  text-overflow: ellipsis;
  text-align: left;
}
</style>